import { configureStore } from '@reduxjs/toolkit';
import templateSelectedModifierItemReducer from './TemplateSelectedModifierItemSlice';

const templateSelectedModifierItemStore = configureStore({
  reducer: {
    templateSelectedModifierItem: templateSelectedModifierItemReducer
  }
});

export default templateSelectedModifierItemStore;